<template>

	<div :title="title || null" :class="finalClass" class="icon-button-table" :style="'--app-button-icon-color:'+color" @click="clickListener">
		<img :src="finalIcon" :alt="iconName" v-if="!loading && finalIcon && iconName">
		<p class="button-text" v-if="(!finalIcon || !iconName) && title">{{title}}</p>
		<AppLoader v-if="loading" :size="13" :color="colorLoader" />
	</div>

</template>

<script>

import AppLoader from "@/shared/components/AppLoader.vue";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		const userStore = useUserStore();
		return {userStore};
	},
	name: "AppTableButton",
	emits: ["click-icon"],
	props: {
		iconName: {type: String},
		active: {type: Boolean, default: false},
		preventChange: {type: Boolean, default: false},
		color: {type: String, default: "var(--color-fill-button-table)"},
		colorLoader: {type: String, default: "#fff"},
		loading: {type: Boolean, default: false},
		outline: {type: Boolean, default: false},
		disabled: {type: Boolean, default: false},
		title: {type: String, default: ''},
	},
	components: {AppLoader},
	data() {
		return {
			isActive: this.active,
		}
	},
	methods: {
		clickListener() {
			if(!this.preventChange) { this.isActive = !this.isActive; }
			this.$emit("click-icon", this.isActive);
		}
	},
	computed: {
		finalClass() {
			let className = this.isActive ? 'active' : '';
			className += this.outline ? 'outline' : '';
			className += this.disabled ? 'disabled' : '';
			return className;
		},
		finalIcon() {
			return new URL("https://img.qromo.io/img/icons/"+this.iconName+(this.userStore.darkMode ? '-dark' : '')+".svg", import.meta.url).href;
		},
	},
	watch: {
		active(newVal) {
			this.isActive = newVal;
		}
	}
}
</script>

<style lang="scss" scoped>

.icon-button-table {
	@include centered;
	width: 100%;
	max-width: 100px;
	height: 32px;
	background-color: var(--app-button-icon-color);
	cursor: pointer;
	transition: all .2s $transition;
	border-radius: 6px;
	&, & * {
		@include noSelect;
	}

	& * {
		pointer-events: none;
	}

	img {
		max-width: 15px;
		max-height: 15px;
	}

	&.disabled {
		pointer-events: none!important;
		opacity: 0.3!important;
	}

	&:hover {
		background-color: var(--color-fill-button-table-hover);
	}

	&.active {
		background-color: var(--color-active-button);
		box-shadow: inset 0 1px 5px var(--color-alpha-4);
		&:hover {
			background-color: #c5f6ed;
		}
	}

	&.outline {
		box-shadow: 0 0 0 1px var(--color-primary) inset;
		background-color: transparent;
		&:hover {
			background-color: var(--app-button-icon-color);
		}
		&.active {
			background-color: var(--color-active-button);
			box-shadow: inset 0 1px 5px var(--color-alpha-4), 0 0 0 1px var(--color-primary) inset;
			&:hover {
				background-color: #c5f6ed;
			}
		}
	}

	.button-text {
		font-size: 14px;
		line-height: 16px;
		text-align: center;
		color: var(--color-primary);
	}

}

</style>